import React from 'react';
import StatsPanel from '../components/StatsPanel';
import { CHORD } from '../constants';

export default function HomePage() {
  return (
    <div>
      <div style={{
        background: CHORD.softBlack,
        padding: '1.25rem 2rem',
        borderBottom: `1px solid ${CHORD.border}`,
      }}>
        <div style={{ fontSize:20, fontWeight:700, marginBottom:2, color: CHORD.beige, letterSpacing:'-0.3px' }}>Dashboard</div>
        <div style={{ fontSize:12, color: CHORD.textFaint, letterSpacing:'0.2px' }}>Overall stats across all platforms — click any metric to drill down</div>
      </div>
      <StatsPanel platform={null} />
    </div>
  );
}
